module.exports = __webpack_public_path__ + "img/4-1.30cddea2.jpg";